var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { Translate } from "../../../../../../../I18N";
import { Button, ConfirmationModal } from "../../../../../../Components/UI";
import { useRevalidator } from 'react-router';
import { notificationAtom } from "../../../../../../atoms";
import { useSetAtom } from 'jotai';
import { dialogConfig } from "./config";


const {
  service,
  headerText,
  warningText,
  acceptButtonText,
  cancelButtonText,
  successText,
  errorText
} = dialogConfig;

const DeleteDialog = ({
  setIsProcessing,
  onSuccess,
  selected,
  disabled





}) => {
  const revalidator = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);
  const [isOpen, setIsOpen] = useState(false);

  const handleDelete = async () => {
    setIsProcessing(true);

    try {
      await service(selected);
      await revalidator.revalidate();
      setIsOpen(false);
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, successText)
      });
      onSuccess();
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, errorText)
      });
    }

    setIsOpen(false);
    setIsProcessing(false);
  };

  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, { color: "error", type: "button", onClick: () => setIsOpen(true), disabled: disabled }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Delete")
    ),
    isOpen && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, headerText),
      warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, warningText),
      acceptButton: /*#__PURE__*/_jsx(Translate, {}, void 0, acceptButtonText),
      cancelButton: /*#__PURE__*/_jsx(Translate, {}, void 0, cancelButtonText),
      onAcceptClick: handleDelete,
      onCancelClick: () => setIsOpen(false) }
    )

    ));

};

export { DeleteDialog };